import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import flash from './modules/flash';
import main from './modules/main';
import meetingAgendas from './modules/meetingAgendas';
import allergyKpis from './modules/allergyKpis';
import audiologyKpis from './modules/audiologyKpis';
import banners from './modules/banners';
import connections from './modules/connections';
import digitalPromo from './modules/digitalPromo';
import fuelFunds from './modules/fuelFunds';
import fuelUtilization from './modules/fuelUtilization';
import onlineLearningLogin from './modules/onlineLearningLogin';
import fuelResources from './modules/fuelResources';
import pricingGuides from './modules/pricingGuides';
import batteryStore from './modules/batteryStore';
import payInvoice from './modules/payInvoice';
import purchaseActivity from './modules/purchaseActivity';
import purchaseActivityFlash from './modules/purchaseActivityFlash';
import vendorPartners from './modules/vendorPartners';
import accounts from './modules/accounts';
import contacts from './modules/contacts';
import locations from './modules/locations';
import createLogger from '../../plugins/logger';

Vue.use(Vuex);

const debug = ['DEV', 'DEBUG'].includes(CONFIG.get('ENV'));

export default new Vuex.Store({
  modules: {
    auth,
    flash,
    main,
    meetingAgendas,
    allergyKpis,
    audiologyKpis,
    banners,
    batteryStore,
    connections,
    digitalPromo,
    fuelFunds,
    fuelUtilization,
    onlineLearningLogin,
    fuelResources,
    payInvoice,
    pricingGuides,
    purchaseActivity,
    purchaseActivityFlash,
    vendorPartners,
    accounts,
    contacts,
    locations,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
